import React, { useEffect, useMemo, useReducer, useState } from 'react';
import { toast } from '../../toasts';
import DetailPageLoader from '../../components/DetailPageLoader/DetailPageLoader';
import { getError } from '../../utils';
import { MdOutlinePayments } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import MessageBox from '../../components/MessageBox';
import paymentService from '../../services/payment.service';
import SingleObjectDocumentManager from '../../components/SingleObjectDocumentManager/SingleObjectDocumentManager';
import PaymentInfo from './PaymentInfo';
import InfoTabs from '../../components/InfoTabs/InfoTabs';
import DetailViewerHeader from '../../components/ObjectIconDisplay/DetailViewerHeader';
import HistoryModal from '../../components/HistoryModal';

const reducer = (state, action) => {
	switch (action.type) {
	case 'FETCH_DEBTS_REQUEST':
		return { ...state, loadingDebts: true };
	case 'FETCH_DEBTS_SUCCESS':
		return { ...state, debts: action.payload, loadingDebts: false };
	case 'FETCH_DEBTS_FAIL':
		return { ...state, loadingDebts: false, error: action.payload };
	case 'FETCH_REQUEST':
		return { ...state, loading: true };
	case 'FETCH_SUCCESS':
		return { ...state, payment: action.payload, loading: false };
	case 'FETCH_FAIL':
		return { ...state, loading: false, error: action.payload };
	default:
		return state;
	}
};

function PaymentDetail() {
	const params = useParams();
	const navigate = useNavigate();

	const { id } = params;

	const [{ loading, error, payment }, dispatch] = useReducer(reducer, {
		debts: [],
		loadingDebts: true,
		payment: {},
		loading: true,
		error: '',
	});

	const [showHistoryLog, setShowHistoryLog] = useState(false);

	const handleShowHistoryLog = () => {
		setShowHistoryLog(true);
	};

	const handleCloseHistoryLog = () => {
		setShowHistoryLog(false);
	};

	useEffect(() => {
		const fetchData = async () => {
			dispatch({ type: 'FETCH_REQUEST' });
			try {
				const result = await paymentService.getDetails(id);
				dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
			} catch (error) {
				dispatch({ type: 'FETCH_FAIL', payload: getError(error) });
			}
		};
		fetchData();
	}, [id]);

	async function editPaymentHandler() {
		navigate(`/AdminScreen/payments/editPayment/${id}`, {
			state: { returnTo: `/AdminScreen/payments/payment/${id}` },
		});
	}

	async function downloadReceiptHandler() {
		try {
			await paymentService.downloadReceipt(id);
		} catch (error) {
			toast.error('Error al generar el recibo');
		}
	}

	const tabbedComponents = useMemo(() => [
		{ 
			eventKey: 'info', 
			title: 'Detalles', 
			component: <PaymentInfo payment={payment} /> 
		},
		{ 
			eventKey: 'documents', 
			title: 'Documentos', 
			component: (
				<div className='p-3'>
					<SingleObjectDocumentManager 
						objectId={id} 
						objectType="payment" 
						documentType="comprobante" 
					/>
				</div>
			) 
		},
	], [payment, id]);

	const headerButtons = [
		{
			label: 'Descargar Recibo',
			onClick: () => downloadReceiptHandler(),
		},
		{
			label: 'Editar',
			onClick: () => editPaymentHandler(),
			type: 'edit',
		},
		{
			label: 'Atrás',
			onClick: () => navigate(-1),
		},
	];

	return (
		<>
			{loading ? (
				<DetailPageLoader entityLabel='pago' />
			) : (
				error ? (
					<MessageBox variant='danger'>{error}</MessageBox>
				) : null
			)}
			<div className='admin-con align-items-center'>
				<HistoryModal 
					model="payment" 
					show={showHistoryLog} 
					handleClose={handleCloseHistoryLog} 
					id={payment._id} 
					isHistory={true}
				/>
				<DetailViewerHeader 
					icon={<MdOutlinePayments />} 
					title={`Cobro ${payment.customId || ''}`} 
					subtitle={payment.debt?.customId ? `Deuda: ${payment.debt.customId}` : null}
					openHistoryLogHandler={handleShowHistoryLog}
					buttons={headerButtons}
				/>
				<div className="info-container">
					<InfoTabs tabbedComponents={tabbedComponents}/>
				</div>
			</div>
		</>
	);
}
export default PaymentDetail;
